<template>
    <div class="widescreen accountbg" style="justify-content: center;align-items: center;display: flex;">
        <div class="box1">
            <div class="box2">
                <div class="box3">
                    <div style="text-align: center; padding: 50px;">
                        <h3 style="color: white;">Autenticando con Microsoft...</h3>
                        <div class="spinner-border text-warning" role="status" style="margin-top: 30px;">
                            <span class="sr-only">Cargando...</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import MainService from "@/services/MainService.js";

export default {
    name: 'AuthCallback',
    data() {
        let ss = new MainService();
        return {
            ss: ss
        };
    },
    mounted() {
        const urlParams = new URLSearchParams(window.location.search);
        const token = urlParams.get('token');
        const error = urlParams.get('error');

        if (error) {
            this.$bvToast.toast('Error al autenticar con Microsoft: ' + error, {
                title: 'Error',
                variant: 'danger',
                autoHideDelay: 5000
            });
            this.$router.push('/login');
            return;
        }

        if (token) {
            this.getUserData(token);
        } else {
            this.$bvToast.toast('Token no recibido', {
                title: 'Error',
                variant: 'danger',
                autoHideDelay: 3000
            });
            this.$router.push('/login');
        }
    },
    methods: {
        getUserData(token) {
            // Guardar el token
            localStorage.setItem('token', JSON.stringify(token));
            
            // Obtener datos del usuario autenticado
            this.axios.get(this.ss.url + '/api/me', {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            })
            .then(response => {
                console.log('Usuario autenticado:', response.data);
                localStorage.setItem('persona', JSON.stringify(response.data.data));
                
                this.$bvToast.toast('Sesión iniciada correctamente', {
                    title: 'Éxito',
                    variant: 'success',
                    autoHideDelay: 3000
                });
                
                // Redirigir al home
                this.$router.push('/');
                this.$router.go();
            })
            .catch(error => {
                console.error('Error obteniendo datos del usuario:', error);
                this.$bvToast.toast('Error al obtener datos del usuario', {
                    title: 'Error',
                    variant: 'danger',
                    autoHideDelay: 5000
                });
                localStorage.clear();
                this.$router.push('/login');
            });
        }
    }
}
</script>

<style scoped>
/* Reutiliza los mismos estilos de tu LoginPage */
.accountbg {
    background: #25272e;
    position: absolute;
    height: 100%;
    width: 100%;
    top: 0;
}

.box1{
    position: relative;
    width: 400px;
    height: 300px;
    background: #191a1f;
    overflow: hidden;
    border-radius: 50px 5px;
}

.box2{
    position: absolute;
    inset: 2px;
    background: #28292d;
    z-index: 1;
    border-radius: 50px 5px;
}

.box3{
    position: absolute;
    inset: 8px;
    width: 380px;
    height: 280px;
    background: #191a1f;
    overflow: hidden;
    border-radius: 50px 5px;
}

.spinner-border {
    width: 3rem;
    height: 3rem;
}
</style>